import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class EventDTO {
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  Id?: number;
  @ApiProperty()
  @MaxLength(500, { message: "eventtittle Code allows maximum 500 characters" })
  eventTitle:string;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  eventDesc:string;
  @ApiProperty()
  @ApiPropertyOptional()
  villageId:number;
  @ApiProperty()
  @IsNotEmpty()
  categoryId:number;
  @ApiProperty()
  @IsNotEmpty({message:"eventstartdate should not be empty"})
  eventStartDate: Date;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  eventStartTime: string;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  eventEndDate: Date;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  eventEndTime: string;
  @ApiProperty({
    default:0
  })
  @ApiPropertyOptional()
  public: number;
  @ApiProperty()
  @ApiPropertyOptional()
  status: boolean;
  @ApiProperty()
  @IsNotEmpty()
  userId:number; 
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  guestIds?:any;
  createdAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  createdUser : number;
  updatedAt : Date;
  updatedUser : number;
  @ApiProperty({
    minimum:1,
    default:1
  })
  versionFlag : number;
  @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } })
  @ApiPropertyOptional()
  attachments?: any[];
}

export class EventUpdateDTO {
  @ApiProperty()
  Id: number;
  @ApiProperty()
  @MaxLength(500, { message: "eventtittle Code allows maximum 500 characters" })
  eventTitle:string;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  eventDesc:string;
  @ApiProperty()
  @ApiPropertyOptional()
  villageId:number;
  @ApiProperty()
  @IsNotEmpty()
  categoryId:number;
  @ApiProperty()
  @IsNotEmpty({message:"eventstartdate should not be empty"})
  eventStartDate: Date;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  eventStartTime: string;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  eventEndDate: Date;
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  eventEndTime: string;
  @ApiProperty({
    default:0
  })
  @ApiPropertyOptional()
  public: number;
  @ApiProperty()
  @ApiPropertyOptional()
  status: boolean;
  @ApiProperty()
  @IsNotEmpty()
  userId:number; 
  @ApiProperty()
  @ApiPropertyOptional()
  @IsOptional()
  guestIds?:any;
  createdAt : Date;
  createdUser : number;
  updatedAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  updatedUser : number;
  @ApiProperty({
    minimum:1,
    default:1
  })
  versionFlag : number;
  @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } })
  @ApiPropertyOptional()
  attachments?: any[];
}

export class EventStatusDTO {
  @ApiProperty()
  @IsNotEmpty({message:"Id should not be empty"})
  @IsNumber()
  Id: number;
  @ApiProperty()
  status: boolean;
  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  updatedUser : number;
}

export class GetEventDTO {
  @ApiProperty()
  @IsNotEmpty({message:"Id should not be empty"})    
  Id:number;   
}

export class EventPagDto {
  @ApiProperty()
  apiVersion:number;
  @ApiProperty()
  skip:number;
}

export class EventRSVPDto {
  @ApiProperty()
  eventId:number;
  @ApiProperty()
  userId:number;
  @ApiProperty()
  rsvp:number;
}
